import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequestErrorOccured } from 'redux/slices/globalSlice';
import axiosInstance from '../../utils/axiosInstance';
import { environment } from '../../utils/environment/environment';

const saveScRefferal = createAsyncThunk('scRefferals/saveScRefferal', async (request, { dispatch }) => {
	try {
		const baseUrl =
        environment.hcServiceBasePostUrl + '/v1/referral';
		const response = await axiosInstance.post(baseUrl, request);
		return response.data;
	} catch (error) {
		dispatch(apiRequestErrorOccured(error));
	}
});

export {saveScRefferal};